import { deleteCreation } from 'api/bot';
import { BotCreation } from 'api/bot/types';
import { Close } from 'components/icons/Close';
import { ConfirmDeleteModal } from 'components/modals/ConfirmDeleteModal';
import { showToast } from 'components/ui/CustomToast';
import { reactQuery } from 'lib/reactQuery';
import Link from 'next/link';
import { useState } from 'react';
import { useMutation } from 'react-query';
import dayjs from 'utils/dayjs.config';

type Props = {
  data: BotCreation;
};

export const BotCreationCard = ({ data }: Props) => {
  const imgUrl = data.drafts[0]?.image_url || '';
  const age = dayjs().diff(dayjs(data.custom_attributes.date_of_birth), 'year').toString();

  const [isOpenSecurityModal, setIsOpenSecurityModal] = useState(false);

  const { mutate, isLoading } = useMutation(deleteCreation);

  return (
    <Link
      prefetch={false}
      href={`/create/${data.id}`}
      className="relative border-2 border-primary rounded-xl overflow-hidden cursor-pointer trans hover:border-brand lg:hover:scale-105"
    >
      <Close
        className="absolute top-2 right-2 z-10 size-7"
        onClick={(e) => {
          e.preventDefault();
          setIsOpenSecurityModal(true);
        }}
      />

      {imgUrl ? (
        <img
          src={imgUrl}
          alt={`Bot In Progress: ${data.id}`}
          className="w-full h-[250px] lg:h-[400px] object-cover object-top z-10 grayscale"
        />
      ) : (
        <div className="w-full h-[250px] lg:h-[400px] bg-gray-400 z-10" />
      )}

      <div className="absolute bottom-0 z-20 bg-gradient-to-t from-[#1f1f1f] to-transparent h-28 w-full" />
      <div className="absolute bottom-0 z-30 flex flex-col md:gap-1 p-3 w-full">
        <div className="flex max-lg:flex-col items-start gap-1 lg:items-center justify-between w-full">
          <h2 className="text-xl font-medium">{data.custom_attributes.ethnicity}</h2>
          <span className="text-stone-300 text-xs border border-white border-opacity-70 rounded-md py-1 px-2  hidden md:block">
            {age} years
          </span>
        </div>
      </div>

      {isOpenSecurityModal && (
        <ConfirmDeleteModal
          onClose={() => setIsOpenSecurityModal(false)}
          message="Are you sure you want to delete this pending Krush?"
          disabledBtns={isLoading}
          onConfirm={() => {
            mutate(data.id, {
              onSuccess: () => {
                showToast({ message: `Pending Krush deleted.`, type: 'success' });
                reactQuery.refetchQueries('myCreations');
                setIsOpenSecurityModal(false);
              }
            });
          }}
        />
      )}
    </Link>
  );
};
